import React from 'react';
import LowStockIconSvg from '../../../../../../assets/icons/low-stock-icon.svg';

export const LowStockIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <img
            src={LowStockIconSvg}
            alt="Low / Out of Stock"
            className={className}
        />
    );
};


